module.exports = __webpack_public_path__ + "img/202509_06.42e115c0.jpg";